import { HeadingLevel } from '../../../../../_helpers/Heading';
import { ItemType } from '../../_types/item.ts';
import { AnchorTarget } from '../../_types/anchor-target.ts';
import {
	SaveConfig,
	SaveButtonState,
	SaveButtonVariant,
} from '../../save/SaveButtonProps';

// SeriesItemCard props
export type SeriesItemCardProps = {
	itemData: SeriesItemData;
	componentData: SeriesItemComponentData;
	cardConfig: SeriesItemCardConfig;

	headingLevel?: HeadingLevel;
	className?: string;
	focused?: boolean;
	hidden?: boolean;
	isComponentFrameVisible?: boolean;
	onSaveButtonClick?: () => void;
};

// Backend SeriesItem class
export type SeriesItemData = {
	authors: AuthorData[];
	contentTitle: string;
	dataLinkEvent: string;
	dateOfSave?: number | null;
	description?: string;
	eyebrowTag?: string;
	imagePath?: string | null;
	itemType: ItemType;
	contentCategory?: string;
	publications: string[];
	publicationDate?: string;
	publicationDateAsDate?: number;
	savable: boolean;
	saveUrl: string | null;
	saved: boolean;
	target: AnchorTarget;
	topics?: string[];
	url: string;

	isSaveRequestInProgress?: boolean; //additional field (not included by the backend class, but used by all savable items)
	saveButtonState?: SaveButtonState; //additional field (not included by the backend class, but used by saved page)
};

export type AuthorData = {
	authorName: string;
	authorPageLink?: string | null;
	dataLinkEvent?: string | null;
};

// Additional data that is the same across all cards within a parent component
// (come from backend with the parent component data)
export type SeriesItemComponentData = {
	saveConfig?: SaveConfig | null;
	ariaLabelPrefix?: string; //in the DynamicContentList called 'readMore'
	writtenByLabel?: string; //in the DynamicContentList called 'writtenBy'
};

// Card config to handle different card types appearance or functionality
export type SeriesItemCardConfig = {
	itemTypeIcon?: string;
	displayImage: boolean;
	imageFallbackList?: string[];
	saveBtnPosition: SaveBtnPosition;
	saveBtnVariant?: SaveButtonVariant;
	descriptionDisabled?: boolean;
};

// Position of the save button inside the card
// Value is the additional css class name for save button
export enum SaveBtnPosition {
	IN_THE_LOWER_RIGHT_CORNER_OF_THE_CARD = 'save-button-lower-right-corner',
	IN_LINE_WITH_ARTICLE_DETAIL = 'save-button-inline-article-detail',
}
